import { useQuery } from 'react-query';
import { getAuthenticatedApiClient } from '../api-client';

const getActs = (eventId: number) =>
  getAuthenticatedApiClient()
    .getActsInEvent({ id: eventId })
    .then((x) => x.data);

export const useGetActs = (eventId: number) => useQuery([eventId, 'acts'], () => getActs(eventId));
